import { Paper, Stack } from '@mui/material'
import shared from '@/components/Settings/settingsShared.module.scss'
import {
  ConnectionsDirectoryListEmpty,
  ConnectionsDirectorySearchEmpty,
} from './ConnectionsDirectoryEmpty'
import ConnectionsDirectoryRow from './ConnectionsDirectoryRow'

export default function ConnectionsDirectoryPanel({
  listEmpty,
  searchNoHits,
  rows,
  menuAnchor,
  menuRowId,
  onOpenRowMenu,
}) {
  if (listEmpty) return <ConnectionsDirectoryListEmpty />
  if (searchNoHits) return <ConnectionsDirectorySearchEmpty />
  return (
    <Paper elevation={0} className={shared.connectionsPaper}>
      <Stack component="ul" direction="column" spacing={0} className={shared.connectionsList}>
        {rows.map((row, index) => (
          <ConnectionsDirectoryRow
            key={row.id}
            row={row}
            isLast={index === rows.length - 1}
            menuAnchor={menuAnchor}
            menuRowId={menuRowId}
            onOpenRowMenu={onOpenRowMenu}
          />
        ))}
      </Stack>
    </Paper>
  )
}
